module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "[Acknowledgments]"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "d7e81911"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c7_r1#d7e6949",
      "id": "d14e359"
    }
  }, [_c('b', [_vm._v("[")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Acknowledgments")]), _c('b', [_vm._v("]")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e82611"
    }
  }, [_vm._v("Writing a book involves many important choices. Most of those choices are about people—people who quietly do their part to get so much good content to the people who need it most. More than ever I am humbled by the way these people do their jobs and fulfill the Lord’s call upon their lives. I understand more than ever how ineffective my ministry would be apart from the choices they have made.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e85111"
    }
  }, [_vm._v("I am thrilled with the opportunity to publish with Thomas Nelson. Joey Paul, Tami Heim, and Mike Hyatt are the kind of partners authors dream about. Entering into relationship with them has been the most delightful part of this process.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e87011"
    }
  }, [_vm._v("Barb Peil from Walk in the Word has been exceptional in getting the project off to a great start and picking it up again to take across the finish line. Her faithfulness to God’s call is inspiring to watch and a rich blessing to experience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e88811"
    }
  }, [_vm._v("Neil Wilson has been fantastic in the role of smoothing and expanding the material into a clear, readable format. Without his help the book just could not have happened. A busy senior pastor is not much without a capable committed editor, and Neil is all that and more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e90311"
    }
  }, [_vm._v("Kathy Elliott, my assistant of nearly twenty years, was again in the center of it all, administrating the process and passing my extensive edits back through the pipeline in every direction.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e91511"
    }
  }, [_vm._v("Janine Nelson, the executive director of Walk in the Word, will do much to get this message of life-change into the hands of people who can choose it for themselves. Without her partnership it’s quite possible you would never have connected with this author or any of the teaching God has entrusted to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e93912"
    }
  }, [_vm._v("Robert Wolgemuth has become so much more than an agent or friend; he truly is an elder to my life and ministry for whom I continually thank the Lord. Seeing his life reproduced and his ministry expanded in his colleagues Andrew and Erik is a beautiful thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e95812"
    }
  }, [_vm._v("I thank God also for the people of Harvest Bible Chapel, before whom we live out the reality of personal choices and their life/death power.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e96712"
    }
  }, [_vm._v("My family has chosen to love me continually, warts and all, and I am greatly humbled by their presence and patience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e97612"
    }
  }, [_vm._v("Most of all, I thank the Lord Jesus Christ for the grace He gives to keep on choosing—better and better all the time. PTL!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4700daf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MacD_ISBN9781418573447_epub_c9_r1.vue
// module id = 75
// module chunks = 0